import { objectToQueryString } from '../../helpers/objectToQueryString';
import { IGetSearchDataFullResponse } from '../../types/search';
import { axiosInstance } from '../axiosInstance';

export const getSearchDataFull = async (
  search: string,
  params?: Record<string, string | number>,
): Promise<IGetSearchDataFullResponse> => {
  const queryString = params ? objectToQueryString(params) : '';

  const response = await axiosInstance.get(
    `/search/full/${search}?${queryString}`,
  );

  return response.data;
};
